import {showNotification} from "@mantine/notifications";
import {
    AiOutlineExclamation,
    AiOutlineInfo,
    AiOutlineLogin
} from "react-icons/ai";


// FNP-958: a caught value is `unknown`, not `any`. Typing it honestly showed
// these helpers were reading `.errors` / `.message` off the value with no
// narrowing at all — under `any` that was an unchecked property access that
// would throw on a non-object rejection (a thrown string, a network failure).
// The guards below are the check the code always needed.
const hasErrorsArray = (e: unknown): e is { errors: { message: string }[] } =>
    typeof e === 'object'
    && e !== null
    && Array.isArray((e as { errors?: unknown }).errors);

export const showErrorNotifications = (e: unknown) => {

    console.debug('handleAppSyncResponseException', e)

    if (hasErrorsArray(e) && e.errors.length > 0) {
        e.errors.forEach((error: { message: string; }) => {
            showErrorNotification(error.message);
        })
    }
}


export const notifySuccess = (message = 'Record saved successfully') => {
    showNotification({
                         title: 'Success',
                         icon: <AiOutlineInfo/>,
                         message: message,
                         color: 'teal',
                     })
}


export const showErrorNotification = (message = 'Error performing the operation') => {
    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    if (message.toLowerCase() === noCurrentUserMessage) {
        notifySessionExpired();
    }

}

export const notifyError = (e: unknown) => {

    console.trace(e);

    // FNP-958: narrowed rather than reading .message off an unknown. A thrown
    // string or a rejected non-Error previously produced undefined here and
    // fell through to the default, which happened to work; an object without a
    // message now takes the same path explicitly.
    const message = e instanceof Error && e.message
        ? e.message
        : 'Error performing the operation'

    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    if (message.toLowerCase() === noCurrentUserMessage) {
        notifySessionExpired();
    }

}

export const notifySessionExpired = (message = 'Redirecting to login page... Please, wait!') => {

    showNotification({
                         title: 'Session Expired',
                         icon: <AiOutlineLogin/>,
                         message: message,
                         color: 'blue',
                     });

    setTimeout(() => {
        window.location.reload();
    }, 3000);

};


// notify access denied
export const notifyAccessDenied = (message = 'Access denied') => {
    showNotification({
                         title: 'Access Denied',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}